export const findById =
  <T extends { id: string }>(array: T[]) =>
  (id: string) =>
    array.find(item => item.id === id)
